 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"add-counselor~add-employee~add-legislation~add-record~auth~edit-mayor~legislation~local-council~meet~a82f5460":"add-counselor~add-employee~add-legislation~add-record~auth~edit-mayor~legislation~local-council~meet~a82f5460","add-counselor~add-employee~add-legislation~add-record":"add-counselor~add-employee~add-legislation~add-record","add-counselor":"add-counselor","add-employee":"add-employee","add-legislation":"add-legislation","add-record~legislation~meetings~registry~users":"add-record~legislation~meetings~registry~users","add-record~registry~view-record":"add-record~registry~view-record","add-record":"add-record","legislation~meetings~registry~users":"legislation~meetings~registry~users","registry":"registry","legislation":"legislation","meetings~users":"meetings~users","meetings":"meetings","users":"users","auth":"auth","edit-mayor":"edit-mayor","local-council":"local-council","view-record":"view-record","dashboard":"dashboard","mayor":"mayor","town-hall":"town-hall"}[chunkId]||chunkId) + "." + {"add-counselor~add-employee~add-legislation~add-record~auth~edit-mayor~legislation~local-council~meet~a82f5460":"a6233b5d","add-counselor~add-employee~add-legislation~add-record":"3f892e93","add-counselor":"647127c4","add-employee":"8e1a7e61","add-legislation":"21057163","add-record~legislation~meetings~registry~users":"a599391b","add-record~registry~view-record":"c6ab8548","add-record":"0c3235b0","legislation~meetings~registry~users":"6b85dea5","registry":"9df5e391","legislation":"98337783","meetings~users":"62411e31","meetings":"138980cf","users":"4899b4f5","auth":"f79cca59","edit-mayor":"ae047b24","local-council":"c01f71b8","view-record":"0104bf49","dashboard":"8873331e","mayor":"ef7165ae","town-hall":"6bd0ecd4"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"add-counselor~add-employee~add-legislation~add-record~auth~edit-mayor~legislation~local-council~meet~a82f5460":1,"add-counselor~add-employee~add-legislation~add-record":1,"add-counselor":1,"add-employee":1,"add-legislation":1,"add-record~legislation~meetings~registry~users":1,"add-record":1,"legislation~meetings~registry~users":1,"registry":1,"meetings~users":1,"meetings":1,"users":1,"edit-mayor":1,"local-council":1,"view-record":1,"dashboard":1,"mayor":1,"town-hall":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"add-counselor~add-employee~add-legislation~add-record~auth~edit-mayor~legislation~local-council~meet~a82f5460":"add-counselor~add-employee~add-legislation~add-record~auth~edit-mayor~legislation~local-council~meet~a82f5460","add-counselor~add-employee~add-legislation~add-record":"add-counselor~add-employee~add-legislation~add-record","add-counselor":"add-counselor","add-employee":"add-employee","add-legislation":"add-legislation","add-record~legislation~meetings~registry~users":"add-record~legislation~meetings~registry~users","add-record~registry~view-record":"add-record~registry~view-record","add-record":"add-record","legislation~meetings~registry~users":"legislation~meetings~registry~users","registry":"registry","legislation":"legislation","meetings~users":"meetings~users","meetings":"meetings","users":"users","auth":"auth","edit-mayor":"edit-mayor","local-council":"local-council","view-record":"view-record","dashboard":"dashboard","mayor":"mayor","town-hall":"town-hall"}[chunkId]||chunkId) + "." + {"add-counselor~add-employee~add-legislation~add-record~auth~edit-mayor~legislation~local-council~meet~a82f5460":"c9f5a90d","add-counselor~add-employee~add-legislation~add-record":"76a811a3","add-counselor":"cab59e1c","add-employee":"cab59e1c","add-legislation":"cab59e1c","add-record~legislation~meetings~registry~users":"824318f6","add-record~registry~view-record":"31d6cfe0","add-record":"7bbf9e0a","legislation~meetings~registry~users":"d253099c","registry":"2090ba31","legislation":"31d6cfe0","meetings~users":"5e0d3bce","meetings":"de3dd2e1","users":"33ac40b1","auth":"31d6cfe0","edit-mayor":"9cb39600","local-council":"281dbb43","view-record":"cab59e1c","dashboard":"c66e108f","mayor":"dec0773f","town-hall":"bb723b24"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/assets/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
